import { useEffect, useState } from 'react';
import { closeIcon, PeoplePurple} from '../../../../assets/images/new-icons';
import { RenderTitle } from '../../../common';
import Button from '../../../common/UI/Button/Button';
import ModalR from '../../../common/UI/Modal/ModalR';
import StyledInput from '../../../common/UI/StyledInput/StyledInput';
import cls from './AddVideoModal.module.scss';

export const AddVideoModal = (comp) => {
    const { isOpen, onClose, onAddVideoUrl } = comp;

    const [videoUrl, setVideoUrl] = useState('');
    const [errorMessage, setErrorMessage] = useState('');


    function isValidURL() {
        const isValid = /^(https?:\/\/)[^\s$.?#].[^\s]*$/;

        return isValid.test(videoUrl);
    }

    const addVideoUrl = () => {
        if (isValidURL()) {
            onAddVideoUrl(videoUrl);
            onClose();
        } else {
            setErrorMessage('Enter Valid URL');
        }
    };

    useEffect(() => {
        setVideoUrl("");
        setErrorMessage("");
    }, [isOpen]);

    return (
        <ModalR
            shadowedContainerStyle={{ maxWidth: '640px', minWidth: '640px', width: '640px' }}
            onClose={() => {
                onClose();
            }}
            isOpen={isOpen}
            backdropColor={true}
            blured={true}
        >
            <div className={cls.duplicateModalContainer}>
                <div className={cls.duplicatingPositionContainer}>
                    <div>
                        <div style={{position: 'absolute', top: '35px', right: '40px'}}>
                            <div onClick={onClose} style={{cursor: 'pointer', backgroundColor: 'transparent', border: 0}}>
                                <img alt="" src={closeIcon} style={{width: '24px', height: '24px'}}/>
                            </div>
                        </div>
                        <div className={cls.titleContainer}>
                            <div className={cls.peopleIcon}>
                                <PeoplePurple style={{width: '24px', height: '24px'}}/>
                            </div>
                            <p className={cls.modalTitle}>Add Video</p>
                        </div>
                    </div>

                    <div className={cls.duplicatingPosition_description}>
                        <div>
                            <RenderTitle title={'Video Url'} tooltipText="Add a video to the editor using an embedded video URL. (e.g., https://www.youtube.com/embed/xxxxxxxx)"/>
                            <StyledInput className={cls.inputField} type="videoUrl" id="videoUrl" name="videoUrl"
                                placeholder="Enter your video url" value={videoUrl} onChange={e => setVideoUrl(e.target.value)} hasError={errorMessage} error={errorMessage}/>
                        </div>
                    </div>

                    <div style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        marginTop: '20px',
                    }}>
                        <Button
                            disabled={videoUrl.trim().length === 0}
                            title="Submit"
                            style={{marginLeft: '0px', width: '165px', height: '41px'}}
                            titleStyle={{textAlign: 'center', padding: '0 2px 0 0'}}
                            clicked={addVideoUrl}
                        />
                    </div>
                </div>

            </div>
        </ModalR>
    );
};
